import type { RelationshipType } from '@/store/sessionTypes'

export function SessionTypeIcon({
  type,
  ring,
  className,
}: {
  type:      RelationshipType
  ring:      string
  className?: string
}) {
  switch (type) {
    case 'practitioner-client':
      return (
        <svg className={className} viewBox="0 0 40 30" width="40" height="30" aria-hidden="true">
          <circle cx="14" cy="15" r="9" fill={ring} opacity="0.45" />
          <circle cx="26" cy="15" r="9" fill={ring} opacity="0.85" />
        </svg>
      )
    case 'parent-child':
      return (
        <svg className={className} viewBox="0 0 40 30" width="40" height="30" aria-hidden="true">
          <circle cx="8" cy="15" r="5" fill={ring} fillOpacity="0.14" stroke={ring} strokeOpacity="0.5" strokeWidth="1.2" />
          <circle cx="32" cy="15" r="5" fill={ring} fillOpacity="0.14" stroke={ring} strokeOpacity="0.72" strokeWidth="1.2" />
          <circle cx="20" cy="15" r="3.5" fill={ring} fillOpacity="0.22" stroke={ring} strokeOpacity="0.88" strokeWidth="1.2" />
          <line x1="13" y1="15" x2="16.5" y2="15" stroke={ring} strokeOpacity="0.22" strokeWidth="0.9" strokeLinecap="round" strokeDasharray="1.5 2.5" />
          <line x1="23.5" y1="15" x2="27" y2="15" stroke={ring} strokeOpacity="0.22" strokeWidth="0.9" strokeLinecap="round" strokeDasharray="1.5 2.5" />
        </svg>
      )
    case 'co-workers':
      return (
        <svg className={className} viewBox="0 0 40 30" width="40" height="30" aria-hidden="true">
          <circle cx="14" cy="15" r="8" fill={ring} opacity="0.75" />
          <circle cx="26" cy="15" r="8" fill={ring} opacity="0.75" />
        </svg>
      )
    case 'other':
      return (
        <svg className={className} viewBox="0 0 40 30" width="40" height="30" aria-hidden="true">
          <circle cx="12" cy="15" r="3" fill={ring} opacity="0.55" />
          <circle cx="20" cy="15" r="3" fill={ring} opacity="0.75" />
          <circle cx="28" cy="15" r="3" fill={ring} opacity="0.95" />
        </svg>
      )
  }
}
